import { render, staticRenderFns } from "./Ertesitesek.vue?vue&type=template&id=61a26a5d&"
import script from "./Ertesitesek.vue?vue&type=script&lang=js&"
export * from "./Ertesitesek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports